import { ShieldCheck, AlertTriangle, CheckCircle2, Cpu } from "lucide-react";
import useCountUp from "@/lib/useCountUp";

const CHECKS = [
  { label: "Multi-factor authentication", ok: true },
  { label: "Backups verified & offline", ok: true },
  { label: "Phishing exposure", ok: false },
  { label: "Vendor access review", ok: false },
  { label: "AI workflow mapped", ok: true },
];

export default function BusinessOperationsVisual() {
  const { ref, value } = useCountUp({ end: 74, duration: 2000 });
  return (
    <div ref={ref} className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden border border-zinc-200 bg-[#fafafa] shadow-[0_20px_60px_-20px_rgba(0,0,0,0.12)] p-6" data-testid="business-ops-visual">
      <div className="absolute inset-0 btr-blueprint-overlay opacity-20" />
      <div className="relative flex items-center justify-between">
        <div>
          <div className="text-[10px] font-display tracking-[0.3em] uppercase text-zinc-500">Operations Review</div>
          <div className="font-display font-bold text-[#111114] text-sm mt-1">Security & AI Readiness</div>
        </div>
        <Cpu className="w-5 h-5 text-[#a2020b]" />
      </div>
      <div className="h-[1px] bg-zinc-200 mt-3" />
      <div className="relative mt-4 grid grid-cols-[1fr_1.6fr] gap-4">
        <div className="bg-white rounded-md border border-zinc-200 p-4 flex flex-col justify-between">
          <div className="text-[9px] tracking-[0.25em] uppercase text-zinc-500 font-display">Posture Score</div>
          <div className="font-display font-extrabold text-[#111114] text-5xl mt-2">{value}</div>
          <div className="h-1.5 mt-3 bg-zinc-100 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-[#a2020b] to-[#c0030e] transition-all duration-[1800ms]" style={{ width: `${value}%` }} />
          </div>
          <div className="text-[9px] font-display tracking-[0.2em] uppercase text-[#a2020b] mt-3">2 items flagged</div>
        </div>
        <ul className="bg-white rounded-md border border-zinc-200 p-3 space-y-2.5">
          {CHECKS.map((c) => (
            <li key={c.label} className="flex items-center gap-2 text-[11px] font-body text-zinc-700">
              {c.ok ? <CheckCircle2 className="w-3.5 h-3.5 text-emerald-600 flex-shrink-0" /> : <AlertTriangle className="w-3.5 h-3.5 text-[#a2020b] flex-shrink-0" />}
              <span className="truncate">{c.label}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="relative mt-4 grid grid-cols-6 gap-1.5">
        {Array.from({ length: 18 }).map((_, i) => (
          <div key={i} className={`h-5 rounded-sm ${i % 7 === 3 ? "bg-[#a2020b]/70 animate-pulse" : "bg-zinc-200"}`} />
        ))}
      </div>
      <div className="absolute bottom-4 right-4 flex items-center gap-2 bg-white border border-[#a2020b]/30 rounded-full px-3 py-1.5 shadow-sm">
        <ShieldCheck className="w-3.5 h-3.5 text-[#a2020b]" />
        <span className="text-[10px] font-display font-bold tracking-[0.2em] uppercase text-[#a2020b]">Monitored</span>
      </div>
      <div className="absolute left-0 right-0 h-[2px] bg-[#a2020b] opacity-60" style={{ animation: "btr-scan 5.5s ease-in-out infinite", boxShadow: "0 0 12px #a2020b" }} />
    </div>
  );
}
